import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { FaRegEye, FaEyeSlash } from "react-icons/fa";
import classes from "../../Styles/common.module.css";

const LoginModal = (props) => {
	const userEmailInputRef = useRef();
	const userPasswordInputRef = useRef();

	const [loginData, setLoginData] = useState([]);
	const [inputError, setInputError] = useState([]);

	const [errorMsg, setErrorMsg] = useState("");

	const hideModal = () => {
		setLoginData([]);
		setInputError([]);
		setErrorMsg("");
		props.onHide();
	};

	const modalOnEsc = () => {
		// do nothing
	}

	const onKeyDown = (event) => { 
		if (event.key === "Enter") 
		loginBtnOnClick();
	}

	const [visible, setVisible] = useState(false);

	const togglePasswordVisibility = () => {
		setVisible(!visible);
	};

	const ForgetPasswordOnClick = () => {
		ForgetPassword();
	}

	function ForgetPassword() {
		props.removeCookies();
		hideModal();
		props.showHideForgetModal();
	}

  	const loginBtnOnClick = () => {
		if (loginData.Email === undefined) {
			setInputError((prevState) => ({
				...prevState,
				Email: (" Email could not be empty."),
			}));
		}
		if (loginData.PASSWORD === undefined) {
			setInputError((prevState) => ({
				...prevState,
				PASSWORD: (" Password could not be empty."),
			}));
		}
		if (Object.values(inputError).filter(v => v !== "").length === 0) {
			UserLogin();
		}
	}

	function UserLogin() {
		props.removeCookies();
		if (loginData.Email !== undefined && loginData.PASSWORD !== undefined) {
			let functionName = "";
			try {
				functionName = "User Login";
				props.onLoading(true, "Logging in, please wait...");
				var encrypted = common.c_EncryptData(loginData.PASSWORD.trim(),);
				const data = {
					Email: loginData.Email.trim(),
					PASSWORD: encrypted.toString(),
					FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
				};
				http
					.post("api/login/UserLogin", data, { timeout: 100000 })
					.then((response) => {
						if (response.data.VALID === "LOGIN_SUCCESS") {
							props.setCookies('USERNAME', response.data.USERNAME, { path: '/' });
							props.setCookies('USER_ID', response.data.USER_MST_GUID, { path: '/' });
							props.setCookies('AUTO_LOGOUT_DURATION', response.data.AUTO_LOGOUT_DURATION, { path: '/' });
							props.setCookies('ROLE_ID', response.data.ROLE_ID, { path: '/' });
							window.location = common.c_getWebUrl() + "Dashboard";
							hideModal();
						} else if (response.data.VALID === "RESET") {
							props.setResetData({
								USER_MST_GUID: response.data.USER_MST_GUID,
								USERNAME: response.data.USERNAME,
								EMAIL: response.data.EMAIL,
								ERROR_MSG: response.data.ERROR_MSG,
							})
							hideModal();
							props.showHideResetModal();
						}
						else {
							setErrorMsg(response.data.ERROR_MSG);
						}
					})
					.catch((err) => {
						setErrorMsg("Failed to log in. Please check email & password is correct.");
						common.c_LogWebError(props.page, functionName, err);
					})
					.finally(() => {
						props.onLoading(false, "Loading...");
					});

			} catch (err) {
				props.onLoading(false, "Loading...");
				setErrorMsg("Failed to log in. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			}
		}
	}

	const inputRequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputRequiredHandler.name;
			const name = event.target.name;
			functionName = inputRequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: (name + " could not be empty."),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: (""),
				}));
			}
			setLoginData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

    return (
		<>
			<Modal show={props.showHide} onHide={modalOnEsc} centered dialogClassName="login-modal">
  			<div className="login-modal-content">
					<Modal.Header style={{ display: "flex", flexDirection: "column", backgroundColor: "#fff" }}>
						<div>
							<img
								src={props.images["Leave App Logo.jpg"]}
								style={{ width: "100%", height: "25%", marginLeft: "0%" }}
								alt="cimation"
							/>
						</div>
					</Modal.Header>
					<Modal.Body>
						<div className="floating-label-group" style={{marginTop: "15px" }}>
							<input
								type="text"
								id="Email"
								name="Email"
								placeholder=" "
								value={loginData.Email}
								onChange={inputRequiredHandler}
								onKeyDown={onKeyDown}
								ref={userEmailInputRef}
								className="form-control"
								autoComplete="off"
							/>
							<label htmlFor="Email">Email</label>
							{inputError.Email && (
								<div className={classes.invalidMessage}>{inputError.Email}</div>
							)}
						</div>

						<div className="floating-label-group" style={{marginTop: "30px" }}>
							<div className="input-container">
								<input
									type={visible ? 'text' : 'password'}
									id="PASSWORD"
									name="Password"
									placeholder=" "
									value={loginData.PASSWORD}
									onChange={inputRequiredHandler}
									onKeyDown={onKeyDown}
									ref={userPasswordInputRef}
									className="form-control"
									autoComplete="off"
								/>
								<label htmlFor="PASSWORD">Password</label>

								<div className="icon-container">
									{visible ? (
										<FaRegEye onClick={togglePasswordVisibility} />
									) : (
										<FaEyeSlash onClick={togglePasswordVisibility} />
									)}
								</div>
							</div>

							{inputError.PASSWORD && (
								<div className={classes.invalidMessage}>{inputError.PASSWORD}</div>
							)}
						</div>
						
						<button 
							id="ForgetPassword" 
							onClick={ForgetPasswordOnClick}
							style={
								{ border: "none", color: "#ea8630", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer"}}>
							Forgot Password?
						</button>
					</Modal.Body>
					<Modal.Footer>
						<div style={{ textAlign: "center", width: "100%" }}>
							<Comp.Button id="btnLogin" style={{ width: "100%", backgroundColor: "#ea8630" }} onClick={loginBtnOnClick}>
								Login
							</Comp.Button>
							<p style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{errorMsg}</p>
							<p style={{ fontSize: "14px", color: "#fff" }}> Copyright © 2025 by Cimation (M) Sdn. Bhd. All rights reserved.</p>
							
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);

};

export default LoginModal;